module.exports = __webpack_public_path__ + "img/prol_mediale_dx.e49aa0e6.png";